import {Button, Form, Modal} from 'antd';
import {
  DocumentFieldsFragment,
  DocumentStatus,
  Maybe,
  useUpdateDocumentMutation
} from 'api/generated';
import {Formik} from 'formik';
import {FormItem, Input} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import {useAccessLevel} from 'hooks/useAccessLevel';
import {canBeApproved} from 'lib/documentUtils';
import React, {useState} from 'react';

type Props = {
  document?: Maybe<DocumentFieldsFragment>;
} & React.ComponentProps<typeof Button>;

export const ApproveDocument: React.FC<Props> = ({document, ...rest}) => {
  const [isOpen, setOpen] = useState(false);
  const {isAdmin} = useAccessLevel();
  const [updateDocument] = useUpdateDocumentMutation();

  if (!document || !isAdmin) return null;
  if (!canBeApproved(document)) return null;

  const initialValues = {
    note: null,
    id: document.id,
    accountId: document.accountId,
    status: DocumentStatus.APPROVED
  };

  const handleSubmit = async (
    input: typeof initialValues,
    {setSubmitting}: FormikHelpers<typeof initialValues>
  ) => {
    try {
      await updateDocument({variables: {input}});
      setOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} type="primary" {...rest}>
        Approve
      </Button>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Approve document"
            okText="Approve"
            open={isOpen}
            afterClose={resetForm}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            onCancel={() => {
              setOpen(false);
            }}>
            <Form layout="vertical">
              <FormItem
                name="note"
                label="Note (optional)"
                extra="This message will be shown to the user.">
                <Input.TextArea name="note" rows={2} />
              </FormItem>
              <input type="submit" hidden />
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
